import { apiClient } from '@/api/api-client';
import {
  PAYOUT_REVIEW_PAGE_SIZE,
  payoutDecisionResultSchema,
  reviewQueuePageSchema,
  type PayoutDecision,
  type ReviewQueuePage,
  type ReviewQueueQuery,
} from './payout-review.contract';

export const payoutReviewService = {
  async getQueue({ status, page }: ReviewQueueQuery): Promise<ReviewQueuePage> {
    const { data } = await apiClient.get<unknown>('/payments/requests/review-queue', {
      params: { status, page, limit: PAYOUT_REVIEW_PAGE_SIZE },
    });
    return reviewQueuePageSchema.parse(data);
  },

  async decide(requestId: number, decision: PayoutDecision): Promise<void> {
    const { data } = await apiClient.post<unknown>(`/payments/requests/${requestId}/validate`, decision);
    payoutDecisionResultSchema.parse(data);
  },
};
